export const dineroRemito = (valor) =>
  Number(valor || 0).toLocaleString("es-AR", {
    style: "currency",
    currency: "ARS",
  });

export const fechaRemitoVista = (valor) => {
  if (!valor) return "-";

  // Conserva el día mostrado en el listado de remitos.
  const texto = String(valor);

  if (/^\d{4}-\d{2}-\d{2}/.test(texto)) {
    const [anio, mes, dia] = texto.slice(0, 10).split("-");
    return `${dia}/${mes}/${anio}`;
  }

  return "-";
};

export const nombreEntidadRemito = (entidad) => {
  if (!entidad) return "-";
  if (typeof entidad === "string") return entidad;

  return (
    entidad.razonsocial ||
    entidad.nombre ||
    entidad.cliente ||
    entidad.proveedor ||
    "-"
  );
};

export const estaAnuladaRemito = (orden) =>
  String(orden?.estado || "").toUpperCase() === "ANULADA";

const suma = (lista, campo) =>
  (lista || []).reduce(
    (total, item) => total + Number(item?.[campo] || 0),
    0
  );

export function resumenOrdenRemito(orden, tipo) {
  const aplicaciones = orden?.aplicaciones || [];
  const esOP = tipo === "OP";

  if (esOP) {
    const t = orden?.totales || {};

    return {
      aplicadoA: Number(
        t.aplicadoA ?? suma(aplicaciones, "aplicadoA")
      ),
      aplicadoB: Number(
        t.aplicadoB ?? suma(aplicaciones, "aplicadoB")
      ),
      aplicadoFlete: Number(
        t.aplicadoFlete ?? suma(aplicaciones, "aplicadoFlete")
      ),
      aplicado: Number(
        t.aplicado ?? suma(aplicaciones, "aplicado")
      ),
      medios: Number(
        t.netoPagado ?? suma(orden?.pagos, "importe")
      ),
      retenciones: Number(
        t.retenciones ?? suma(orden?.retenciones, "importe")
      ),
      anticipos: Number(
        t.saldoFavorConsumido ??
          suma(orden?.saldosFavorAplicados, "importe")
      ),
      generado: Number(t.saldoFavorGenerado || 0),
    };
  }

  return {
    aplicadoA: Number(
      orden?.totalAplicadoA ?? suma(aplicaciones, "aplicadoA")
    ),
    aplicadoB: Number(
      orden?.totalAplicadoB ?? suma(aplicaciones, "aplicadoB")
    ),
    aplicadoFlete: 0,
    aplicado: Number(
      orden?.totalAplicaciones ?? suma(aplicaciones, "importe")
    ),
    medios: Number(
      orden?.totalMedios ?? suma(orden?.medios, "importe")
    ),
    retenciones: Number(
      orden?.totalRetenciones ?? suma(orden?.retenciones, "importe")
    ),
    anticipos: Number(
      orden?.totalSaldosFavorAplicados ??
        suma(orden?.saldosFavorAplicados, "importe")
    ),
    generado: Number(orden?.totalSaldoFavorGenerado || 0),
  };
}

export const numeroRemitoAplicado = (aplicacion) =>
  aplicacion?.remito?.codrem ??
  aplicacion?.codrem ??
  aplicacion?.numeroRemito ??
  (typeof aplicacion?.remito === "string"
    ? aplicacion.remito
    : "-");

export function nombreMedioRemito(medio) {
  const tipo = String(
    medio?.medio || medio?.tipo || ""
  ).toLowerCase();

  const nombres = {
    efectivo: "Efectivo",
    transferencia: "Transferencia",
    cheque: "Cheque",
    cheque_tercero: "Cheque",
    cheque_propio: "Cheque",
    icheq: "eCheq",
    echeq: "eCheq",
  };

  return nombres[tipo] || tipo || "-";
}

export function referenciaMedioRemito(medio) {
  const referencia =
    medio?.nroCheque ||
    medio?.idICheq ||
    medio?.refTransferencia ||
    medio?.referencia ||
    medio?.numero;

  if (referencia) return String(referencia);

  if (medio?.carteraItem) {
    const valor = medio.carteraItem;

    if (typeof valor === "object") {
      return String(
        valor.nro ||
          valor.nroCheque ||
          valor.idICheq ||
          valor._id ||
          "-"
      );
    }

    return `Cartera: ${valor}`;
  }

  return "-";
}